import {
  ROUTE_CONFIRM_PAYOUT_EMAIL,
  ROUTE_CREATE_GAME_ORDER,
  ROUTE_CREATE_GAME_BET_ORDER,
  ROUTE_CREATE_MEMBERSHIP_ORDER,
  ROUTE_CREATE_ORDER,
  ROUTE_DELETE_ACCOUNT,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_FULL_SIGNUP,
  ROUTE_GAME_LANDING_REDIRECT,
  ROUTE_GAME_REDIRECT,
  ROUTE_INVITE_LANDING,
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_MEMBERSHIP_SIGNUP,
  ROUTE_OPTIONAL_BET,
  ROUTE_REFERRAL_SIGNUP,
  ROUTE_RESET_PASSWORD,
  ROUTE_ROUTINES_CAMPAIGN,
  ROUTE_SIGNUP,
  ROUTE_ACCOUNTABILITY_PARTNER_INVITE_LANDING,
} from '#src/store/location/actions';

import * as completePayoutRequest from './complete-payout-request';
import * as createGameBetOrder from './createGameBetOrder';
import * as createGameOrder from './createGameOrder';
import * as createOrder from './create-order';
import * as createMembershipOrder from './createMembershipOrder';
import * as deleteAccount from './delete-account';
import * as fullSignup from './full-signup';
import * as gameLandingRedirect from './game-landing-redirect';
import * as gameRedirect from './game-redirect';
import * as inviteAccountabilityLanding from './invite-accountability-landing';
import * as inviteLanding from './invite-landing';
import * as login from './login';
import * as logout from './logout';
import * as membershipSignup from './membership-signup';
import * as optionalBet from './optionalBet';
import * as referralSignup from './referral-signup';
import * as routinesCampaign from './routines-campaign';
import * as signup from './signup';

export function generateStaticRoutes({ ctx, graphqlClient } = {}) {
  const routes = {
    [ROUTE_CONFIRM_PAYOUT_EMAIL]: {
      path: completePayoutRequest.path,
      component: completePayoutRequest.component,
      thunk: completePayoutRequest.thunk(graphqlClient),
      name: 'Complete Payout Request',
    },
    [ROUTE_CREATE_GAME_BET_ORDER]: {
      path: createGameBetOrder.path,
      component: createGameBetOrder.component,
      thunk: createGameBetOrder.thunk(),
      name: 'Create Game Bet Order',
    },
    [ROUTE_CREATE_GAME_ORDER]: {
      path: createGameOrder.path,
      component: createGameOrder.component,
      thunk: createGameOrder.thunk(),
      name: 'Create Game Order',
    },
    [ROUTE_CREATE_ORDER]: {
      path: createOrder.path,
      component: createOrder.component,
      thunk: createOrder.thunk(),
      name: 'Create Order',
    },
    [ROUTE_CREATE_MEMBERSHIP_ORDER]: {
      path: createMembershipOrder.path,
      component: createMembershipOrder.component,
      thunk: createMembershipOrder.thunk(),
      name: 'Create Membership Order',
    },
    [ROUTE_DELETE_ACCOUNT]: {
      path: deleteAccount.path,
      component: deleteAccount.component,
      name: 'Delete Account',
      thunk: deleteAccount.thunk(),
    },
    [ROUTE_FORGOT_PASSWORD]: {
      path: '/login/forgot-password',
      component: 'ForgotPassword',
      name: 'Forgot Password',
    },
    [ROUTE_FULL_SIGNUP]: {
      path: fullSignup.path,
      component: fullSignup.component,
      thunk: fullSignup.thunk(),
      name: 'Full Signup',
    },
    [ROUTE_GAME_LANDING_REDIRECT]: {
      path: gameLandingRedirect.path,
      component: gameLandingRedirect.component,
      thunk: gameLandingRedirect.thunk({ graphqlClient }),
      name: 'Game Landing',
    },
    [ROUTE_GAME_REDIRECT]: {
      path: gameRedirect.path,
      component: gameRedirect.component,
      thunk: gameRedirect.thunk(),
      name: 'Game',
    },
    [ROUTE_ACCOUNTABILITY_PARTNER_INVITE_LANDING]: {
      path: inviteAccountabilityLanding.path,
      component: inviteAccountabilityLanding.component,
      thunk: inviteAccountabilityLanding.thunk({ graphqlClient }),
      name: 'Invite Landing for Accountability Partner',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
    },
    [ROUTE_INVITE_LANDING]: {
      path: inviteLanding.path,
      component: inviteLanding.component,
      thunk: inviteLanding.thunk({ graphqlClient }),
      name: 'Invite Landing',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
    },
    [ROUTE_LOGIN]: {
      path: login.path,
      component: login.component,
      thunk: login.thunk(),
      name: 'Login',
    },
    [ROUTE_LOGOUT]: {
      path: logout.path,
      component: logout.component,
      thunk: logout.thunk({ ctx, graphqlClient }),
      name: 'Logout',
    },
    [ROUTE_MEMBERSHIP_SIGNUP]: {
      path: membershipSignup.path,
      component: membershipSignup.component,
      thunk: membershipSignup.thunk({ ctx, graphqlClient }),
      name: 'Membership Signup',
    },
    [ROUTE_OPTIONAL_BET]: {
      path: optionalBet.path,
      component: optionalBet.component,
      thunk: optionalBet.thunk(),
      name: 'Optional Bet',
    },
    [ROUTE_REFERRAL_SIGNUP]: {
      path: referralSignup.path,
      component: referralSignup.component,
      thunk: referralSignup.thunk({ graphqlClient }),
      name: 'Referral Signup',
      componentNamespace: 'skyParallax',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
    },
    [ROUTE_RESET_PASSWORD]: {
      path: '/login/reset-password',
      component: 'ResetPassword',
      name: 'Reset Password',
    },
    [ROUTE_ROUTINES_CAMPAIGN]: {
      path: routinesCampaign.path,
      component: routinesCampaign.component,
      thunk: routinesCampaign.thunk({ graphqlClient }),
      name: 'Routines Campaign Landing',
      options: {
        hideHeader: true,
        hideFooter: true,
      },
    },
    [ROUTE_SIGNUP]: {
      path: signup.path,
      component: signup.component,
      thunk: signup.thunk(),
      name: 'Signup',
    },
  };

  return routes;
}
